import addModal from './addModal.vue';
import { MENULIST, TYPELIST, ROLELIST, COLUMNS } from './utils';
import { panelList, delPanel } from './request';
export default {
  components: {
    addModal
  },
  data() {
    return {
      form: {
        type: undefined
      },
      tableData: [],
      MENULIST,
      TYPELIST,
      ROLELIST,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      COLUMNS,
      addVisible: false,
      isEdit: false
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await panelList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    onSearch() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该面板'), {
        confirmButtonText: '确定'
      }).then(() => {
        delPanel({
          panelId: val.id
        }).then(() => {
          _this.$message.success(_this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    },
    menuChange() {
      this.form.type = undefined;
    }
  }
};